module.exports = __webpack_public_path__ + "img/added_to_shortcut.803e5e5.png";